import saleType1 from '../assets/promo_sale_types_icons/promo_sale_type_1_icon.png'
import saleType2 from '../assets/promo_sale_types_icons/promo_sale_type_2_icon.png'
import saleType10 from '../assets/promo_sale_types_icons/promo_sale_type_10_icon.png'
import saleType12 from '../assets/promo_sale_types_icons/promo_sale_type_12_icon.png'
import saleType13 from '../assets/promo_sale_types_icons/promo_sale_type_13_icon.png'
import saleType20 from '../assets/promo_sale_types_icons/promo_sale_type_20_icon.png'
import saleType21 from '../assets/promo_sale_types_icons/promo_sale_type_21_icon.png'
import saleType30 from '../assets/promo_sale_types_icons/promo_sale_type_30_icon.png'
import saleType40 from '../assets/promo_sale_types_icons/promo_sale_type_40_icon.png'
import saleType41 from '../assets/promo_sale_types_icons/promo_sale_type_41_icon.png'
import saleType44 from '../assets/promo_sale_types_icons/promo_sale_type_44_icon.png'
import saleType50 from '../assets/promo_sale_types_icons/promo_sale_type_50_icon.png'
import saleType51 from '../assets/promo_sale_types_icons/promo_sale_type_51_icon.png'
import saleType62 from '../assets/promo_sale_types_icons/promo_sale_type_62_icon.png'
import saleType63 from '../assets/promo_sale_types_icons/promo_sale_type_63_icon.png'
import saleType70 from '../assets/promo_sale_types_icons/promo_sale_type_70_icon.png'
import saleType71 from '../assets/promo_sale_types_icons/promo_sale_type_71_icon.png'
import saleType72 from '../assets/promo_sale_types_icons/promo_sale_type_72_icon.png'
import saleType81 from '../assets/promo_sale_types_icons/promo_sale_type_81_icon.png'

import {ReactComponent as DownloadIcon} from "../assets/download_icon.svg";
import {ReactComponent as UploadExcelIcon} from "../assets/upload_excel_icon.svg";
import {ReactComponent as UploadExcelImageIcon} from "../assets/upload_image_icon.svg";
import {ReactComponent as UploadExcelCloudIcon} from "../assets/upload_excel_cloud_icon.svg";
import {ReactComponent as DeleteIcon} from "../assets/delete_icon.svg";
import {ReactComponent as ArchiveIcon} from "./../assets/flyersScreen/archive_icon.svg";


export const MENU_LIST_PROMOTIONS_ITEMS = [
    {
        name: 'Download Empty Excel File',
        type: 'button',
        isDownload: true,
        filesFormat: ".xls,.xlsx",
        isMultiply: false,
        code: 'DownloadEmptyExcelFile',
        icon: <DownloadIcon/>
    },
    // {
    //     name: 'Upload Promos File',
    //     type: 'file',
    //     isDownload: false,
    //     filesFormat: ".xls,.xlsx",
    //     isMultiply: false,
    //     code: 'UploadPromosFile',
    //     text: 'To see the Upload Promotions Excel format'
    // },
    {
        name: 'Upload Promos/Items Excel File',
        type: 'file',
        isDownload: false,
        filesFormat: ".xls,.xlsx",
        isMultiply: false,
        code: 'UploadPromosAndItemsFile',
        text: 'To see the Upload Promotions and Items Excel format',
        icon: <UploadExcelIcon/>
    },
    // {
    //     name: 'Export Promos to Excel',
    //     type: 'file',
    //     isDownload: true,
    //     filesFormat: ".xls,.xlsx",
    //     isMultiply: false,
    //     code: 'ExportPromosToExcel'
    // },
    // {
    //     name: 'Download Items Sample File',
    //     type: 'file',
    //     isDownload: true,
    //     filesFormat: ".xls,.xlsx",
    //     isMultiply: false,
    //     code: 'DownloadItemsSampleFile'
    // },
    // {
    //     name: 'Upload Items File',
    //     type: 'file',
    //     isDownload: false,
    //     filesFormat: ".xls,.xlsx",
    //     isMultiply: false,
    //     code: 'UploadItemsFile',
    //     text: 'To see the Upload Items Excel format'
    // },

    // {
    //     name: 'Upload Promos & Items Excel File',
    //     type: 'file',
    //     isDownload: false,
    //     filesFormat: ".xls,.xlsx",
    //     isMultiply: false,
    //     code: 'UploadPromosItemsFile',
    //     text: 'To see  the Upload Promos & Items Excel format'
    // },
    {
        name: 'Upload Promo & Item Images',
        type: 'button',
        isDownload: false,
        filesFormat: ".xls,.xlsx",
        isMultiply: false,
        code: 'UploadItemsImagesFiles',
        icon: <UploadExcelImageIcon/>
    },
    {
        name: 'Upload Promo Images',
        type: 'file',
        isDownload: false,
        filesFormat: ".jpeg, .jpg, .png",
        isMultiply: true,
        code: 'UploadPromoImages',
        icon: <UploadExcelImageIcon/>
    },
    {
        name: 'Upload Item Images',
        type: 'file',
        isDownload: false,
        filesFormat: ".jpeg, .jpg, .png",
        isMultiply: true,
        code: 'UploadItemImages',
        icon: <UploadExcelImageIcon/>
    },
    {
        name: 'Export Promos/Items Excel File',
        type: 'button',
        isDownload: true,
        filesFormat: ".xls,.xlsx",
        isMultiply: false,
        code: 'ExportPromosItemsToExcel',
        icon: <DownloadIcon/>

    },
    // {
    //     name: 'Export Items to Excel',
    //     type: 'file',
    //     isDownload: true,
    //     filesFormat: ".xls,.xlsx",
    //     isMultiply: false,
    //     code: 'ExportItemsToExcel'
    // },
    // {
    //     name: 'Upload Item Images',
    //     type: 'file',
    //     isDownload: true,
    //     filesFormat: ".xls,.xlsx",
    //     isMultiply: false,
    //     code: 'UploadItemImages'
    // },
];

export const MENU_LIST_STORE_ITEMS = [
    {
        name: 'Download Empty Excel File',
        type: 'button',
        isDownload: true,
        filesFormat: ".xls,.xlsx",
        isMultiply: false,
        code: 'DownloadEmptyExcelForStoreFile',
        icon: <DownloadIcon/>,
        tooltip: 'Fill in all Item attributes in this Excel.'
    },
    {
        name: 'Upload Items Excel File',
        type: 'file',
        isDownload: false,
        filesFormat: ".xls,.xlsx",
        isMultiply: false,
        code: 'UploadItemsForStoreFile',
        text: 'To see the Upload Promotions and Items Excel format',
        icon: <UploadExcelIcon/>,
    },
    {
        name: 'Upload Item Images',
        type: 'button',
        isDownload: false,
        filesFormat: ".xls,.xlsx",
        isMultiply: false,
        code: 'UploadItemImagesForStoreFile',
        icon: <UploadExcelImageIcon/>,
    },
    {
        name: 'Archive Items via Excel',
        type: 'file',
        isDownload: true,
        filesFormat: ".xls,.xlsx",
        isMultiply: false,
        code: 'ArchiveItemsFromStoreFile',
        icon: <ArchiveIcon/>,
        tooltip: 'Select an Excel file with a list of items to archive.'
    },
];

export const MENU_LIST_FRAME_ITEMS = [
    {
        name: 'Upload Frames Excel',
        type: 'file',
        isDownload: false,
        filesFormat: ".xls,.xlsx",
        isMultiply: false,
        code: 'UploadFramesExcel',
        icon: <UploadExcelCloudIcon/>
    },
    {
        name: 'Download Frames Excel',
        type: 'button',
        isDownload: true,
        filesFormat: ".xls,.xlsx",
        isMultiply: false,
        code: 'DownloadFramesExcel',
        icon: <DownloadIcon/>
    },
    {
        name: 'Delete All Flyers Frames',
        type: 'button',
        isDownload: true,
        filesFormat: ".xls,.xlsx",
        isMultiply: false,
        code: 'DeleteAllFlyerFrames',
        icon: <DeleteIcon/>
    },
];

export const TABS_LIST_PROMOTIONS_ITEMS_UNLINK = [
    {
        name: 'Promotions'
    },
    {
        name: 'Items'
    },

]


export const PROMO_CAPTIONS_TEXT_ENG = [
    {
        name: 'New Product',
        type: 1
    },
    {
        name: 'Starting at {CurrencySymbol} {BuyPrice}',
        type: 2
    },
    {
        name: '{CurrencySymbol} {BuyPrice} per {SellingUnit}',
        type: 10
    },
    {
        name: 'Pay {CurrencySymbol} {BuyPrice} instead of {CurrencySymbol} {RegPrice}',
        type: 12
    },
    {
        name: 'Buy {BuyQty} at {CurrencySymbol} {BuyPrice}',
        type: 20
    },
    {
        name: 'Buy any {BuyQty} at {CurrencySymbol} {BuyPrice}',
        type: 21
    },
    {
        name: '{PercentOff} Off of Regular Price {CurrencySymbol} {RegPrice}',
        type: 30
    },
    {
        name: 'The 2nd at {CurrencySymbol} {BuyPrice}',
        type: 40
    },
    {
        name: 'Buy 1 Get 1 at {PercentOff} off',
        type: 41
    },
    {
        name: 'The 2nd at {PercentAt}',
        type: 44
    },
    {
        name: 'Buy {BuyQty}, Get 1 free',
        type: 50
    },
    {
        name: 'Buy {BuyQty}, Get 1 free, the cheapest of all',
        type: 51
    },
    {
        name: 'Buy {CurrencySymbol} {BuyAmount}, Get {CurrencySymbol} {GetAmount} Back',
        type: 62
    },
    {
        name: 'Buy any {CurrencySymbol} {BuyAmount}, Get {CurrencySymbol} {GetAmount} Off',
        type: 63
    },
    {
        name: 'Buy {BuyQty} and Get 1 {GetItemCode} {Caption} Free',
        type: 80
    },
    {
        name: 'Buy {BuyQty} and Get 1 {GetItemCode} {Caption} Free',
        type: 81
    },
]

export const PROMO_CAPTIONS_TEXT_HEBREW = [
    {
        name: 'חדש על המדף',
        type: 1
    },
    {
        name: 'החל מ- {BuyPrice} {CurrencySymbol}',
        type: 2
    },
    {
        name: '{BuyPrice} {CurrencySymbol} ל{SellingUnit}',
        type: 10
    },
    {
        name: 'שלם {BuyPrice} {CurrencySymbol} במקום {RegPrice} {CurrencySymbol}',
        type: 12
    },
    {
        name: 'קנה {BuyQty} ב- {BuyPrice} {CurrencySymbol}',
        type: 20
    },
    {
        name: 'קנה כל {BuyQty} ב- {BuyPrice} {CurrencySymbol}',
        type: 21
    },
    {
        name: '{PercentOff} הנחה ממחיר ליח {RegPrice} {CurrencySymbol}',
        type: 30
    },
    {
        name: 'השני ב- {BuyPrice} {CurrencySymbol}',
        type: 40
    },
    {
        name: 'קנה 1, קבל 1 ב- {PercentOff} הנחה',
        type: 41
    },
    {
        name: 'השני ב- {PercentAt}',
        type: 44
    },
    {
        name: 'קנה {BuyQty}, קבל 1 מתנה',
        type: 50
    },
    {
        name: 'קנה {BuyQty}, קבל 1 מתנה, הזול מביניהם',
        type: 51
    },
    {
        name: 'קנה {BuyAmount} {CurrencySymbol}, קבל {GetAmount} {CurrencySymbol} בחזרה',
        type: 62
    },
    {
        name: 'קנה כל {BuyAmount} {CurrencySymbol}, קבל {GetAmount} {CurrencySymbol} בחזרה',
        type: 63
    },
    {
        name: 'קנה {BuyQty} וקבל {GetItemCode} {Caption} חינם',
        type: 80
    },
    {
        name: 'קנה {BuyQty} וקבל {GetItemCode} {Caption} חינם',
        type: 81
    },
];



export const saleTypesDropdownData = [
    {
        saleTypeId: 1,
        saleTypeData: {
            isChangeableRequisite: false,
            isChangeableBenefit: false,
            nameRequisite: 'BuyQty',
            nameBenefit: 'SalePrice',
            defaultRequisite: 0,
            defaultBenefit: 0,
            imageSrc: saleType1
        }
    },
    {
        saleTypeId: 2,
        saleTypeData: {
            isChangeableRequisite: false,
            isChangeableBenefit: true,
            nameRequisite: 'BuyQty',
            nameBenefit: 'SalePrice',
            defaultRequisite: 1,
            defaultBenefit: 10,
            imageSrc: saleType2
        }
    },
    {
        saleTypeId: 10,
        saleTypeData: {
            isChangeableRequisite: false,
            isChangeableBenefit: true,
            nameRequisite: 'BuyQty',
            nameBenefit: 'SalePrice',
            defaultRequisite: 1,
            defaultBenefit: 29.99,
            imageSrc: saleType10
        }
    },
    {
        saleTypeId: 11,
        saleTypeData: {
            isChangeableRequisite: false,
            isChangeableBenefit: true,
            nameRequisite: 'BuyQty',
            nameBenefit: 'SalePrice',
            defaultRequisite: 1,
            defaultBenefit: 29.99,
            imageSrc: saleType10
        }
    },
    {
        saleTypeId: 12,
        saleTypeData: {
            isChangeableRequisite: false,
            isChangeableBenefit: true,
            nameRequisite: 'BuyQty',
            nameBenefit: 'SalePrice',
            defaultRequisite: 1,
            defaultBenefit: 22,
            imageSrc: saleType12
        }
    },
    {
        saleTypeId: 13,
        saleTypeData: {
            isChangeableRequisite: true,
            isChangeableBenefit: true,
            nameRequisite: 'LimitQty',
            nameBenefit: 'SaveAmount',
            defaultRequisite: 0,
            defaultBenefit: 2,
            imageSrc: saleType13
        }
    },
    {
        saleTypeId: 20,
        saleTypeData: {
            isChangeableRequisite: true,
            isChangeableBenefit: true,
            nameRequisite: 'BuyQty',
            nameBenefit: 'SalePrice',
            defaultRequisite: 3,
            defaultBenefit: 36,
            imageSrc: saleType20
        }
    },
    {
        saleTypeId: 21,
        saleTypeData: {
            isChangeableRequisite: true,
            isChangeableBenefit: true,
            nameRequisite: 'BuyQty',
            nameBenefit: 'SalePrice',
            defaultRequisite: 3,
            defaultBenefit: 36,
            imageSrc: saleType21
        }
    },
    {
        saleTypeId: 30,
        saleTypeData: {
            isChangeableRequisite: false,
            isChangeableBenefit: true,
            nameRequisite: 'BuyQty',
            nameBenefit: 'GetPctOff',
            defaultRequisite: 1,
            defaultBenefit: 20,
            imageSrc: saleType30
        }
    },
    {
        saleTypeId: 40,
        saleTypeData: {
            isChangeableRequisite: false,
            isChangeableBenefit: true,
            nameRequisite: 'BuyQty',
            nameBenefit: 'SalePrice',
            defaultRequisite: 1,
            defaultBenefit: 2,
            imageSrc: saleType40
        }
    },
    {
        saleTypeId: 41,
        saleTypeData: {
            isChangeableRequisite: false,
            isChangeableBenefit: true,
            nameRequisite: 'BuyQty',
            nameBenefit: 'GetPctOff',
            defaultRequisite: 1,
            defaultBenefit: 20,
            imageSrc: saleType41
        }
    },
    {
        saleTypeId: 44,
        saleTypeData: {
            isChangeableRequisite: false,
            isChangeableBenefit: true,
            nameRequisite: 'BuyQty',
            nameBenefit: 'PctAt',
            defaultRequisite: 1,
            defaultBenefit: 20,
            imageSrc: saleType44
        }
    },
    {
        saleTypeId: 50,
        saleTypeData: {
            isChangeableRequisite: true,
            isChangeableBenefit: false,
            nameRequisite: 'BuyQty',
            nameBenefit: 'GetQty',
            defaultRequisite: 2,
            defaultBenefit: 1,
            imageSrc: saleType50
        }
    },
    {
        saleTypeId: 51,
        saleTypeData: {
            isChangeableRequisite: true,
            isChangeableBenefit: false,
            nameRequisite: 'BuyQty',
            nameBenefit: 'GetQty',
            defaultRequisite: 3,
            defaultBenefit: 1,
            imageSrc: saleType51
        }
    },
    {
        saleTypeId: 62,
        saleTypeData: {
            isChangeableRequisite: true,
            isChangeableBenefit: true,
            nameRequisite: 'BuyAmount',
            nameBenefit: 'GetAmountOff',
            defaultRequisite: 100,
            defaultBenefit: 20,
            imageSrc: saleType62
        }
    },
    {
        saleTypeId: 63,
        saleTypeData: {
            isChangeableRequisite: true,
            isChangeableBenefit: true,
            nameRequisite: 'BuyAmount',
            nameBenefit: 'GetAmountOff',
            defaultRequisite: 100,
            defaultBenefit: 20,
            imageSrc: saleType63
        }
    },
    {
        saleTypeId: 70,
        saleTypeData: {
            isChangeableRequisite: true,
            isChangeableBenefit: true,
            nameRequisite: 'BuyQty',
            nameBenefit: 'SalePrice',
            defaultRequisite: 1,
            defaultBenefit: 9.99,
            imageSrc: saleType70
        }
    },
    {
        saleTypeId: 71,
        saleTypeData: {
            isChangeableRequisite: false,
            isChangeableBenefit: true,
            nameRequisite: 'BuyQty',
            nameBenefit: 'SalePrice',
            defaultRequisite: 1,
            defaultBenefit: 9.99,
            imageSrc: saleType71
        }
    },
    {
        saleTypeId: 72,
        saleTypeData: {
            isChangeableRequisite: false,
            isChangeableBenefit: true,
            nameRequisite: 'BuyQty',
            nameBenefit: 'SalePrice',
            defaultRequisite: 1,
            defaultBenefit: 9.99,
            imageSrc: saleType72
        }
    },
    {
        saleTypeId: 80,
        saleTypeData: {
            isChangeableRequisite: true,
            isChangeableBenefit: true,
            nameRequisite: 'BuyQty',
            nameBenefit: 'GetItemCode',
            defaultRequisite: 5,
            defaultBenefit: 12345678,
            imageSrc: saleType81
        }
    },
]

export const USER_ROLES = [
    {
        value: "1",
        label: "Viewer"
    },
    {
        value: "2",
        label: "Editor"
    },
    {
        value: "3",
        label: "Admin"
    },

]


